import { Stack, TooltipHost, Link, DirectionalHint, FontIcon, getTheme } from '@fluentui/react';
import * as React from 'react';
import { NavigationState } from './NavigationState';

const iconStyles: React.CSSProperties = {
  fontSize: 20
};

const calloutProps = { gapSpace: 0 };

export interface NavigationCardLinksProps {
  iconState: NavigationState;
  allowedStates?: NavigationState;
  onNavigationClick(target: NavigationState): void;
}

export const NavigationCardLinks: React.FunctionComponent<NavigationCardLinksProps> = props => {
  const { palette } = getTheme();

  const iconLinkStyle = {
    ...iconStyles,
    backgroundColor: palette.neutralLight
  };

  return (
    <Stack>
      <Stack.Item>
        <TooltipHost content="Review" calloutProps={calloutProps} directionalHint={DirectionalHint.rightCenter}>
          <Link
            disabled={props.iconState === NavigationState.REVIEW}
            onClick={(): void => props.onNavigationClick(NavigationState.REVIEW)}
          >
            <FontIcon iconName="ReviewRequestSolid" className="p-1" style={iconStyles} />
          </Link>
        </TooltipHost>
      </Stack.Item>
      <Stack.Item>
        <TooltipHost content="Settings" calloutProps={calloutProps} directionalHint={DirectionalHint.rightCenter}>
          <Link
            disabled={props.iconState === NavigationState.SETTINGS}
            onClick={(): void => {
              props.onNavigationClick(NavigationState.SETTINGS);
            }}
          >
            <FontIcon iconName="ConfigurationSolid" className="p-1" style={iconLinkStyle} />
          </Link>
        </TooltipHost>
      </Stack.Item>
      <Stack.Item>
        <TooltipHost content="Analytics" calloutProps={calloutProps} directionalHint={DirectionalHint.rightCenter}>
          <Link disabled={true} onClick={(): void => props.onNavigationClick(NavigationState.ANALYTICS)}>
            <FontIcon iconName="BarChart4" className="p-1" style={iconLinkStyle} />
          </Link>
        </TooltipHost>
      </Stack.Item>
    </Stack>
  );
};
